export default __webpack_public_path__ + "static/media/logo-eid.cd0ba9bb.png";